import { ChevronRightIcon } from '@heroicons/react/24/solid';
import React from 'react';

interface teamCardButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  className: string;
  rotate: string;
}
export const TeamCardButton = ({ disabled, onClick, className, rotate }: teamCardButtonProps) => {
  return (
    <button
      disabled={disabled ?? false}
      className={`h-8 w-8 rotate-90 rounded-full p-2 shadow-xl transition  duration-500 ${className}`}
      onClick={onClick}
    >
      <ChevronRightIcon className={rotate} />
    </button>
  );
};
